import { render } from "./UserActivities.vue?vue&type=template&id=57db8721&scoped=true"
import script from "./UserActivities.vue?vue&type=script&lang=js"
export * from "./UserActivities.vue?vue&type=script&lang=js"

import "./UserActivities.vue?vue&type=style&index=0&id=57db8721&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57db8721"]])

export default __exports__